import * as React from "react";
import Accordion from "react-bootstrap/Accordion";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import "./routes.css";
import newsAnnPhoto from "../img/newsAnnPhoto.jpg";

// Newsletter archive, newest first. Each issue: {title, body}.
const issues = [
  {
    title: "Spring & Summer 2010",
    body: (
      <>
        <h5 className="subTitle">
          Correcting Rotations for NMR&rsquo;ers, Part II
        </h5>
        <p>
          I&rsquo;ve been working on rotations for years, especially the last
          six or seven, and mostly they take time to work out. Slight rotations
          can be the crankiest in fact, but all rotations involve muscles of
          rotation and the spine.
        </p>
        <p>
          Rotations in the torso, be they in the hips, the mid-back, or the
          shoulders/cervicals, are complicated and, especially in the case of
          scoliosis, can take numbers of sessions to work out. However, there
          are certain muscles that are invariably implicated and others that
          are implicated after getting the primary ones initially worked out.
          The initial muscles that you&rsquo;ll be working with are: serratus
          anterior, low trapezius, psoas and gluteus maximus. These four
          muscles are the beginning and may blow each other out in Triads.
          Please see my DVD or ask someone who has from Alive and Well!.
          (I&rsquo;d love to teach a class on Triads. If you&rsquo;re
          interested, please send name, address and phone number to{" "}
          <a href="mailto:bodymindspiritanatomy@gmail.com">
            bodymindspiritanatomy@gmail.com
          </a>{" "}
          and we&rsquo;ll be in touch.)
        </p>
        <p>
          A typical triad pattern in hip rotations will involve three of the
          following: glut maximus, anterior serratus, low trap, and psoas and
          may switch off more than one of the other muscles. The ones that
          make up the Triad depend on the rotation. At a certain point, after
          a couple of corrections, the pattern can switch to the mirroring set
          of muscles being switched off. In other words, rather than left
          glut, right low trap switching off right psoas, right glut, left low
          trap, is switching off left psoas. Usually it will switch back to
          the primary offending pattern after a correction or two.
        </p>
        <p>
          The person on the table may note that the same muscle patterns are
          being tested over and over and it appears they aren&rsquo;t
          correcting. In fact, we are re-correcting them each time they get
          switched off due to a change in alignment brought about by other
          corrections we&rsquo;re doing in between. What is happening is the
          following: the same muscle pattern is being tested over and over
          again to ensure that it is switching on as the alignment of the
          skeleton changes in response to other patterns being corrected in
          between. The fact that we have to keep correcting a particular
          pattern is a good thing because with each new alignment attained we
          correct the offending pattern, which means that as the person moves
          through myriad normal alignment changes in daily life the pattern
          will still switch on as needed.
        </p>
        <p>
          With each pattern we correct there is the possibility that the
          original offending pattern has switched off again. We want to make
          sure it is switching on as the person&rsquo;s alignment changes.
        </p>
        <p>
          A telltale sign that an offending pattern has switched off again is
          the following: after accomplishing better alignment the body reverts
          to misalignment after a correction. It is imperative to go back to
          the implicated pattern and make sure it hasn&rsquo;t switched off.
          This stands for any chronic problem you&rsquo;re trying to correct.
        </p>
        <p>
          It is imperative to go back and check the pattern(s) that
          chronically shut(s) down as the alignment incrementally changes as
          per the red flags: reversion to misalignment, recurrence of pain
          gotten rid of earlier, a muscle seizing up that was relaxed a moment
          ago. As we move through life our alignment changes minute to minute.
          We want all our muscle patterns to work no matter what alignment we
          are in; we don&rsquo;t want a pattern to only work in a particular
          alignment. That is exactly what pulls us back into chronic
          misalignments and pain.
        </p>
        <p>
          Just this morning I was working on a client who has trouble with her
          left shoulder, which is much built up between her scapula and spine
          causing a shoulder rotation toward the ceiling when she is prone.
          One of the problems was the pattern between the supraspinatus and
          the low trap. First the supra switched off the low trap, which we
          corrected. Then the triad of rhomboid to supra switched off the low
          trap, which we corrected. We did some triad work with both rhomboids
          and anterior serratus&rsquo; and she started getting discomfort in
          the upper shoulder. I checked the supra to the low trap and the low
          trap was getting switched off again, so we corrected it again. Then
          we worked with the serratus, the rhomboids, the rectus
          femoris&rsquo;, and various other spinal problem patterns. When
          checking her cervicals to her low back and rectus femoris she got a
          spasm in the shoulder area. Back we went to see if the supra was
          once again switching off the low trap. It was and once again we
          corrected it. Then we corrected the triad we had uncovered involving
          the serratus, rhomboid, and rectus femoris. With each correction we
          could feel the supra releasing at a deeper and deeper level. When
          you work this way you have much better staying power with each
          session and you get into the deep layers that can&rsquo;t be reached
          initially.
        </p>
        <div className="missionQuote">
          <strong>Tip of the season:</strong> Check the diaphragm and jolts
          when a muscle turns off at odd times or doesn&rsquo;t correct right
          away.
        </div>
        <p>Good luck, any questions feel free to give me a call. Ann</p>
      </>
    ),
  },
  {
    title: "Fall 2009",
    body: (
      <>
        <h5 className="subTitle">Correcting Rotations, Part I</h5>
        <p>
          Rotations are more often than not systemic. The muscles involved
          tend to be on the diagonal from one another until you get into
          deeper layers and then they can switch to a line of force and the
          opposite diagonal for a correction or two.
        </p>
        <p>
          When I work with rotations, I usually start with four muscles: the
          low traps, the psoas&rsquo;, the serratus&rsquo; anterior, and the
          gluteus maximus&rsquo; to see what is strong and what is switching
          off. I definitely check triads. See my DVD Reactive Triads™ or ask
          someone who has.
        </p>
        <p>
          Muscles must appropriately switch on to improve alignment. Notice,
          when you activate a muscle, whether alignment improves or worsens.
          Work with the muscles toward improvement.
        </p>
        <p>
          For example: imagine in the prone position one glut is rotated
          toward the ceiling. Having the person press down on one serratus
          anterior brings better alignment, the other worse. Testing the low
          trapezius in the prone position, one brings better alignment, the
          other worse. Activating the opposite psoas to the raised glut should
          bring better alignment. The three muscles that bring better
          alignment to the glut maximus in question are the muscles you will
          be working with, at least at first, in the pattern of reactive pairs
          and triads. There will most likely come a time within this process
          where you will find that the opposite muscle pattern is suddenly
          switching off, for a correction or two, and then reverts back to the
          original offending pattern as your work brings you closer and closer
          to deep muscles close to the skeleton.
        </p>
        <p>
          After working with the original problem muscle patterns adequately,
          sometimes a lot of work, sometimes none or not much, you will move
          to the skeletal erectors in conjunction with these four muscles and
          the low abdominals. Start with checking the four above indicated
          muscles against the cervicals, then the thoracics, then lumbar,
          stimulate the sacrum. Correct as you go, working out those small
          spinal muscles that are switching off the muscles you&rsquo;re
          working with.
        </p>
        <p>
          After making all corrections necessary, go back to what didn&rsquo;t
          originally switch off even though you expected it to when you
          initially activated the various erectors or the initial patterns and
          see if they switch off now. This is important. The ones that show up
          the second time around and that you then correct are the very ones
          that otherwise draw the body back into misalignment after the person
          gets off your table.
        </p>
        <p>
          Don&rsquo;t get caught in thinking &ldquo;I already corrected
          that&rdquo; or &ldquo;I already tested that and it worked, even
          though I thought it wasn&rsquo;t going to.&rdquo; The patterns that
          chronically switch off in response to changes in body posture are
          the very ones that you need to chronically check back with to make
          sure they are still switching on, to make sure they will switch on
          no matter what the alignment.
        </p>
        <div className="missionQuote">
          <strong>Tip of the season:</strong> Recheck key patterns throughout
          the session. Just because you corrected a key pattern once during a
          session doesn&rsquo;t mean other work you&rsquo;ve done during the
          session to improve skeletal alignment isn&rsquo;t affecting it,
          notably exposing new muscle fibers that aren&rsquo;t activating and,
          hence, that muscle that was working a moment ago may be switching
          off again in that pattern you corrected earlier. You need to
          recheck, especially when the skeletal alignment reverts in response
          to something you just corrected and if a muscle that was relaxed is
          now tight again. This creates real staying power from a session.
        </div>
        <p>Good luck, any questions feel free to give me a call. Ann</p>
      </>
    ),
  },
  {
    title: "Spring 2009",
    body: (
      <>
        <h5 className="subTitle">Important Nutritional Information</h5>
        <p>
          I went to Kripalu Yoga Center this past February and March and
          learned some really important nutritional information from John
          Bagnulo, PhD, Kripalu&rsquo;s nutritionist, and from Marc Grossman,
          a behavioral optometrist and acupuncturist with a practice in Rye,
          NY.
        </p>
        <p>
          According to John, at this latitude from October to March the sun is
          not intense enough to provide us with enough vitamin D to sustain
          us. We need to be taking 5,000 to 10,000 IUs daily during that time
          of the year. D creates a natural antibiotic in our system, hence
          because the sun is not intense enough for us to create that
          antibiotic in our systems, winter time is flu season.
        </p>
        <p>
          D must be present to properly process calcium in our system. It is
          also a hormone regulator and can become even more crucial during
          those change of life times.
        </p>
        <p>
          Vitamin A, which we typically get a lot of in our American diet,
          must be present to process D properly. Word to the wise, A is an
          antioxidant and there are studies that show that taking any
          antioxidant in supplemental form not made from whole foods can have
          a neutral to damaging effect. Apparently, antioxidants in such
          extracted form seat themselves on the DNA kill switch of a cell and
          keep the cell from dying. So we don&rsquo;t get renewed healthy
          replacements, we get proliferation of unhealthy cells.
        </p>
        <p>
          D can be toxic, so it is smart to know what your D levels are. Check
          out D*action on the web for an inexpensive way to monitor your
          vitamin D and also check out Mercola.com for lots of helpful
          information regarding D and other health information.
        </p>
        <p>
          Receiving this information about antioxidants and vitamin D was a
          saving grace for me. I was getting headaches once a month for four
          days straight. At one point I&rsquo;d started taking a whole foods
          supplement of greens and that seemed to help. During the summer I
          thought I&rsquo;d conquered the problem. Then winter rolled around
          and the headaches returned. I went to Kripalu to de-stress and
          conquer those headaches and learned about D. Voila, problem solved.
          Well, almost. It turned out I needed antibiotics for Lyme Disease as
          well. I&rsquo;ve also taken to eating lots of sweet potatoes and
          yams, and homemade applesauce. John is a proponent of the
          Paleolithic diet. These food sources give you proverbial bang for
          your nutritional buck when it comes to intestinal health and getting
          enough fiber to keep your colon healthy, so are really worth
          including regularly in your diet.
        </p>
        <p>
          If you&rsquo;re interested in a class on colon health please call me
          for information at <a href="tel:8605994533">(860) 599-4533</a>.
        </p>
        <p>
          Since returning from Marc Grossman&rsquo;s workshop at Kripalu on
          eye nutrition, I&rsquo;ve started to add kale and orange and red
          peppers to my diet. Those contain primary nutrients needed for eye
          health: lutein, taurine, zeaxanthin. Nope, I&rsquo;d never heard of
          them either.
        </p>
        <p>
          I love Kripalu. I thought I knew plenty about nutrition. These guys
          have kept me up on nutrition I didn&rsquo;t know I didn&rsquo;t
          know. Check out Marc Grossman&rsquo;s website{" "}
          <a
            href="https://www.naturaleyecare.com/"
            target="_blank"
            rel="noreferrer"
          >
            naturaleyecare.com
          </a>{" "}
          for more detailed information on wholistic eye care (he&rsquo;s a
          great guy too), and the D*action website{" "}
          <a
            href="https://www.grassrootshealth.net/"
            target="_blank"
            rel="noreferrer"
          >
            grassrootshealth.net
          </a>{" "}
          for more information on vitamin D and an inexpensive way to get
          your own levels tested and monitored.
        </p>
        <div className="missionQuote">
          <strong>Tip of the season, for all of you NMR folks:</strong> When
          a muscle doesn&rsquo;t let go as much as it should, find other
          muscles it is also switching off, then go back and release the
          muscle for all of them at once. Keep checking possible muscles
          until it really releases a good amount.
        </div>
      </>
    ),
  },
  {
    title: "Winter 2008",
    body: (
      <>
        <h5 className="subTitle">Getting Ready for Winter: Breathe</h5>
        <p>
          Winter winds are starting to blow; the solstice is creeping up on
          us. Just as we were getting used to longer days and warmer weather,
          the days are suddenly shorter. Winter brings to my mind cozy fires,
          blankets of snow, hibernation. Hibernation recalls animals in caves
          sleeping, the rise and fall of the breath.
        </p>
        <p>
          Breathing is so important. When we can&rsquo;t catch our breath, or
          our breath catches so we can&rsquo;t fully breathe, it is quite
          unpleasant.
        </p>
        <p>
          Try this if your breath catches: allow the front of your chest to
          gently and organically respond as you depress your scapula (your
          shoulder blades) down toward your waist and hold them there, keeping
          your shoulders relaxed and away from your ears. Do this a few times
          to fully contract those muscles, then relax without slumping. Relax
          and allow your rib cage to expand under your armpits; allow your
          breath to cause your chest to rise and allow your ribs in the back
          to separate and expand.
        </p>
        <p>
          If this fails, do some comfortable stretching that your body is
          asking for and try again. If that fails, try doing some quick
          vertical stimulation and massage along your sternum (where your ribs
          come together in the front of your body) and thump your thyroid
          (just under your throat). Relax and breathe; try depressing your
          scapula a few more times, exploring how to release the tension
          holding back your breath. Take as full and deep a breath as you can.
          Finally, try grabbing your waist and squeezing it, letting your
          scapula move down your back. This will gently force your chest open
          and can relax the implicated back muscles (usually the posterior
          inferior serratus).
        </p>
        <p>
          Using these little techniques can be a great way to relax just
          before falling asleep at night, our mini hibernation. Winter, here
          we come!
        </p>
        <div className="missionQuote">
          <strong>Tip of the season:</strong> Eat more raw fruits and
          vegetables even though it&rsquo;s winter. We evolved eating far more
          raw food than we do these days. Raw foods have enzymes in them that
          supplement the enzymes we produce in our gut. We don&rsquo;t
          actually produce enough enzymes for proper digestion. Therefore, we
          need to eat raw in order to properly digest. Eat raw with every meal
          to keep your digestive system and your colon healthy.
        </div>
        <p>Stay warm! Ann</p>
      </>
    ),
  },
  {
    title: "Summer 2008",
    body: (
      <>
        <h5 className="subTitle">
          Welcome current clients, previous clients, potentially new clients,
          interested parties and professionals
        </h5>
        <p>
          There are a few topics we&rsquo;ll cover today. The first regards an
          exciting <Link to="/store">new 2 disc DVD</Link> of techniques
          developed by Ann Watkins that is oriented toward professionals in
          practice and instructors (perhaps someone like yourself or someone
          you know). Reactive Triads™ gives the viewer a comprehensive
          introduction to concepts not seen elsewhere in the world of
          bodywork. At the end there are directives for further study and
          information. Ann Watkins, through continued study and application in
          an evolving practice, has put together what constitutes a Chronic
          Pain Breakthrough! She and Randy Shepherd integrate Reactive Triads™
          with other techniques to bring you lasting bodywork. Our mission is
          to improve the quality of life on the planet, one person at a time.
          Our massage therapy is a terrific adjunct to many other effective
          therapies for the client or the practitioner. Check out our Store
          for further information and reviews on the DVD.
        </p>
        <h5 className="subTitle">
          Also announcing the completion of our Green Studio
        </h5>
        <p>
          Beautiful airy cathedral ceilings with radiant floor heat and hot
          water powered by our solar collectors. This keeps costs down and
          lightens our footprint on the planet. See pictures at{" "}
          <Link to="/greenStudio">Green Studio</Link>.
        </p>
      </>
    ),
  },
];

function Resources() {
  return (
    <div className="pageBg">
      <div className="container">
        <div className="pageCard">
          <h2 className="pageTitle">Resources</h2>

          <p className="pageLead">
            Free reading, press coverage, our newsletter archive, and links we
            recommend.
          </p>

          <div className="row g-4">
            <div className="col-md-6">
              <div className="productCard" style={{ marginTop: 0, height: "100%" }}>
                <h4 className="profileName">A Moment for Yourself</h4>
                <p>
                  Ann&rsquo;s short notes on self care, meditation, and
                  feeling better in your body.
                </p>
                <Link to="/aMomentForYourself">
                  <Button>Read the Archive ››</Button>
                </Link>
              </div>
            </div>
            <div className="col-md-6">
              <div className="productCard" style={{ marginTop: 0, height: "100%" }}>
                <h4 className="profileName">Conscious Anatomy™</h4>
                <p>
                  Sign up for information about bodywork and movement classes,
                  courses and freebies.
                </p>
                <a
                  href="https://www.bodymindspiritanatomy.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Button>Visit bodymindspiritanatomy.com ››</Button>
                </a>
              </div>
            </div>
          </div>

          {/* Press */}
          <h3 className="sectionTitle">Press &amp; News</h3>
          <h4 className="profileName">
            Reprogramming Muscles: New Harmony delivers the cutting edge in
            holistic healing
          </h4>
          <p className="profileCred">
            The Stonington Times, by Russ Morey, Times Staff Writer
          </p>
          <div className="profile" style={{ marginTop: 0 }}>
            <img
              src={newsAnnPhoto}
              className="profilePhoto"
              alt="Ann Watkins working with a client"
            />
            <div className="profileBody">
              <p>
                With light pouring through the skylights of the high vaulted
                ceilings of their rooms, massage therapists Ann Watkins and
                Randy Shepherd bring a whole new kind of therapy to eastern
                Connecticut.
              </p>
              <p>
                &ldquo;Neuromuscular reprogramming is based on the idea that
                when muscles overcompensate, other muscles are not doing their
                job. The solution is not just massaging muscles that hurt, but
                finding the root of the problem and alleviating the
                overcompensation. That&rsquo;s when healing really
                occurs,&rdquo; explained Watkins.
              </p>
              <p>
                Watkins and Shepherd both studied at Alive and Well!, a world
                renowned, cutting edge school located in Corte Madera, Ca.
                After both became certified and moved back to the area in the
                late 1990&rsquo;s, they helped expand their business, New
                Harmony, now based in a spacious, new addition to their home
                at 13 River Crest Drive in Pawcatuck.
              </p>
              <p>
                While specializing in neuromuscular reprogramming, Watkins and
                Shepherd also offer many traditional massage techniques,
                including deep-tissue, shiatsu and acupressure. Watkins is
                also starting a new program called &ldquo;moving from the
                inside out,&rdquo; a project that will put her master&rsquo;s
                degree in dance movement therapy to work. The couple will be
                offering massage classes, and Watkins will soon release an
                instructional DVD &ldquo;Neuromuscular Triads.&rdquo; For more
                information, call (860) 599-4533.
              </p>
            </div>
          </div>

          {/* Newsletter archive */}
          <h3 className="sectionTitle">E-News Archive</h3>
          <p>
            Our seasonal e-news from 2008 to 2010, with discoveries and ideas
            for feeling better and being healthier and more vibrant. The
            rotation articles are written for NMR practitioners.
          </p>
          <Accordion className="therapyAccordion">
            {issues.map((issue, i) => (
              <Accordion.Item eventKey={String(i)} key={issue.title}>
                <Accordion.Header>{issue.title}</Accordion.Header>
                <Accordion.Body>{issue.body}</Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>

          {/* Links */}
          <h3 className="sectionTitle">Links We Recommend</h3>
          <ul className="courseList">
            <li>
              <a
                href="https://www.alivewell.com/"
                target="_blank"
                rel="noreferrer"
              >
                <strong>Alive &amp; Well! Institute of Conscious BodyWork</strong>
              </a>
              <span>
                Neuromuscular Reprogramming practitioners. Our alma mater in
                bodywork.
              </span>
            </li>
            <li>
              <a
                href="https://neurokinetictherapy.com/"
                target="_blank"
                rel="noreferrer"
              >
                <strong>NeuroKinetic Therapy</strong>
              </a>
              <span>Neuromuscular Reprogramming practitioners.</span>
            </li>
            <li>
              <a
                href="https://shantalamusic.com/benjy/"
                target="_blank"
                rel="noreferrer"
              >
                <strong>Benjy Wertheimer</strong>
              </a>
              <span>Music. See also the <Link to="/omProject">OM Project</Link>.</span>
            </li>
          </ul>

          {/* Contact */}
          <div className="contactBox">
            <h4 className="subTitle" style={{ marginTop: 0 }}>
              Questions, comments, testimonials?
            </h4>
            <p style={{ marginBottom: 0 }}>
              Send them to{" "}
              <a href="mailto:bodymindspiritanatomy@gmail.com">
                bodymindspiritanatomy@gmail.com
              </a>
              . Please note that newharmony email addresses are not currently
              supported. For now, please only use the gmail address. Thanks!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Resources;
